/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Ticker } from '~/Chrono';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _active = false;
let _delayMs = 1000 / 60;
let _first: DOMHighResTimeStamp = null;
let _delta: DOMHighResTimeStamp = null;
let _ratio: number = null;
let _previous: DOMHighResTimeStamp = null;
let _elapsed: DOMHighResTimeStamp = null;
let _callback: (ticker: Ticker) => void = null;

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function UpdateStart(): void
{
    _active = true;
    UpdateTick();
}

/**
 * @return {void}
 */
export function UpdateStop(): void
{
    _active = false;
}

/**
 * @return {void}
 */
export function UpdateTick(): void
{
    let now: DOMHighResTimeStamp = performance.now();

    _delta = _previous ? now - _previous : now;
    _elapsed = _first ? now - _first : now;
    _ratio = _delta / _delayMs;
    _previous = now;

    if (_callback) {
        _callback(UpdateGetTicker());
    }

    if (_active) {
        setTimeout(UpdateTick, _delayMs);
    }
}

/**
 * @return {void}
 */
export function UpdateGetTicker(): Ticker
{
    return {
        elapsed: _elapsed,
        delta: _delta,
        ratio: _ratio,
    };
}

/**
 * @return {void}
 */
export function UpdateSetCallback(callback: (ticker: Ticker) => void): void
{
    _callback = callback;
}

/**
 * @return {void}
 */
export function UpdateInit(): void
{
    _elapsed = 0;
}
